import { render, staticRenderFns } from "./ClarifyIncomeAddModal.vue?vue&type=template&id=1b146578&"
import script from "./ClarifyIncomeAddModal.vue?vue&type=script&lang=ts&"
export * from "./ClarifyIncomeAddModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports